<!-- eslint-disable -->
<template lang="pug">
    .forgot-box
        .forgot-box__header
            | {{ $i18n.t('auth.auth_forgotPassword_header') }}
        .forgot-box__body
            div.forgot-box__text(v-html="$i18n.t('auth.auth_forgotPassword_bodyText')")
            form.forgot-box__form(action="javascript://" @submit="submitForm")
                .forgot-box__item
                    cs-input(
                        :class="{'cs-input--error': errors.has('email')}"
                        type="email"
                        :placeholder="$i18n.t('auth.auth_forgotPassword_emailPlaceholder')"
                        v-model="email"
                        v-validate="'required|email'"
                        name="email"
                        :data-vv-as="$i18n.t('auth.auth_forgotPassword_emailPlaceholder').toLowerCase()"
                    )
                    help-text(v-show="errors.has('email')" :error="errors.has('email')")
                        | {{ errors.first('email')}}
                cs-button(
                    type="submit"
                    color="blue"
                    :loading="isLoading"
                    :fullWidth="true"
                ) {{ $i18n.t('auth.auth_forgotPassword_button') }}
            .forgot-box__footer
                .forgot-box__link-container
                    router-link.forgot-box__link(:to="{name: 'login'}")
                        | {{ $i18n.t('auth.auth_common_auth') }}
</template>

<script>
    /*eslint-disable*/
    import AuthApi from '../../api/auth'
    import HelpText from '../../elements/HelpText.vue'
    export default {
        components: {
            HelpText,
        },
        data() {
            return {
                isLoading: false,
                email: ''
            }
        },
        methods: {
            submitForm() {
                if (!this.isLoading) {
                    return this.$validator.validateAll()
                    .then(isValid => {
                        if (isValid) {
                            this.isLoading = true;
                            return AuthApi.forgotPassword(this.email);
                        }
                    }, error => {
                        this.$toasted.error(this.$i18n.t('errors.fill_form'));
                    })
                    .then(response => {
                        if (response) {
                            this.$toasted.success('Мы отправили ссылку на указанный email для восстановления пароля');
                            this.isLoading = false;
                        } else {
                            this.$toasted.error(this.$i18n.t('errors.fill_form'));
                        }
                    }, error => {
                        this.$toasted.error('Произошла ошибка. Вы указали неверный email адрес');
                        this.isLoading = false;
                    })
                }
                return Promise.resolve()
            }
        }
    }
</script>

<style lang="scss" scoped>
		.forgot-box {
				font-size: 16px;
				line-height: 26px;
				margin: 0 auto;
				background-color: $x-color-white;
				@include media($sm) {
						border-radius: 40px;
						max-width: 400px;
				}
				@include media($md) {
						max-width: 600px;
				}
		}

    .forgot-box__header {
        font-size: 32px;
        line-height: 38px;
        font-weight: 500;
        text-align: center;
        padding-top: 40px;
    }

    .forgot-box__body {
        padding-top: 13px;
    }

    .forgot-box__footer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .forgot-box__divider {
        border: 0;
        margin: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: calc(100% - 60px);
    }

		.forgot-box__link-container {
				padding: 20px 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
		}

		.forgot-box__link {
				color: $hsl-color-blue-56;
				text-decoration: underline;
				&:hover {
						color: $hsl-color-blue-56;
						text-decoration: none;
				}
		}

		.forgot-box__form {
				max-width: 260px;
				@include media($md) {
						max-width: 300px;
				}
				margin: 0 auto;
		}

		.forgot-box__text {
				text-align: center;
				padding-bottom: 23px;
				margin: 0 auto;
				max-width: 280px;
				@include media($md) {
						max-width: 350px;
				}
		}

		.forgot-box__item {
				padding-bottom: 14px;
		}
</style>
